import { render, staticRenderFns } from "./ProductListingV2.vue?vue&type=template&id=4ae3b228&scoped=true&"
import script from "./ProductListingV2.vue?vue&type=script&lang=js&"
export * from "./ProductListingV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductListingV2.vue?vue&type=style&index=0&id=4ae3b228&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae3b228",
  null
  
)

export default component.exports